import removeFromCart from './remove-from-cart';
import addToCart from './add-to-cart';
import pageView from './page-view';
import buttonClick from './button-click';
import productDetail from './product-detail';
import productImpression from './product-impression';
import productClick from './product-click';
import form from './form';
import checkout from './checkout';
import siteSearch from './site-search';
import promotionClick from './promotion-click';
import promotionView from './promotion-view';
import sale from './sale';

/**
 * Alias for the useful methods we want to export out of this folder
 */
export default {
    removeFromCart,
    addToCart,
    pageView,
    checkout,
    sale,
    buttonClick,
    productDetail,
    productImpression,
    promotionClick,
    promotionView,
    productClick,
    form,
    siteSearch,
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/tracking/index.js